import { analytics } from './segment';

/**
 * How a user landed on their current variant for an experiment.
 *
 *   - `random`  — standard weighted random selection (the default path).
 *   - `forced`  — the experiment definition's `forceVariant` predicate
 *                 returned a value (e.g. paid-ad UTM, direct-organic
 *                 traffic, embedded-webview opt-out).
 *   - `override` — `?exp_NNN=V` query-param override (QA / dev tooling).
 *
 * Used by analysts to filter experiment results — typically
 * `enrollment_method = 'random'` for production analysis. Values are
 * `snake_case` per the segment-component-interaction rule.
 */
export type EnrollmentMethod = 'random' | 'forced' | 'override';

type Params = {
  experiment: number;
  variant: number;
  enrollmentMethod: EnrollmentMethod;
};

export function trackExperimentEnrollment({
  experiment,
  variant,
  enrollmentMethod,
}: Params) {
  // log experiment enrollment to segment
  analytics.identify({
    traits: {
      experiment,
      variant,
      enrollment_method: enrollmentMethod,
    },
  });
}
